import * as React from 'react';
import { TextReviewCard } from './components/TextReviewCard';

import useMediaQuery from '@mui/material/useMediaQuery';

import * as style from './textReviewsNew.module.scss';
import { opacity100 } from './textReviewsNew.module.scss';

export const TextReviewsNew = ({ data, eng=false }) => {

  const [slideNextDisabled, setSlideNextDisabled] = React.useState(false);
  const [slidePrevDisabled, setSlidePrevDisabled] = React.useState(false);
  const isMobile = useMediaQuery('(max-width:767px)');

  const updatePosition = () => {
    if (swiperEl.current) {
      setSlideNextDisabled(swiperEl.current?.swiper.isEnd);
      setSlidePrevDisabled(swiperEl.current?.swiper.isBeginning);
    }
  };
  const swiperEl = React.useRef();
  React.useEffect(() => {
    if (swiperEl.current) {
      Object.assign(swiperEl.current, {
        slidesPerView: 1,
        spaceBetween: 5,
        //centeredSlides: true,
        loop: true,
        watchSlidesProgress: true,
        slideVisibleClass: opacity100,
        breakpoints: {
          767: {
            slidesPerView: 1,
            spaceBetween: 30,
          },

          1100: {
            slidesPerView: 2,
            //width: 980,
            spaceBetween: 30,
          },
        },
        pagination: {
          type: isMobile ? false : "fraction",
        }
      });
      swiperEl.current.initialize();
      updatePosition();
    }
  }, [isMobile]);
  swiperEl.current?.addEventListener('reachbeginning', updatePosition);
  swiperEl.current?.addEventListener('reachend', updatePosition);
  swiperEl.current?.addEventListener('resize', updatePosition);
  return (
    <div className={`${style.textReviews} container`}>
      <swiper-container
        ref={swiperEl}
        className={style.mySwiper}
        init="false"
        style={{
          '--swiper-pagination-bottom': '-62px'
        }}
      >
        {data.map((elem, index) => (
          <swiper-slide key={index}>
            <TextReviewCard data={elem} eng={eng}/>
          </swiper-slide>
        ))}
      </swiper-container>
      <button
        aria-label="swiper-button-next"
        className={`${style.swiperButtonNext} ${slidePrevDisabled && `${style.swiperButtonDisabled}`}`}
        onClick={() => {
          swiperEl.current.swiper.slidePrev();
        }}
      />
      <button
        aria-label="swiper-button-prev"
        className={`${style.swiperButtonPrev} ${slideNextDisabled && `${style.swiperButtonDisabled}`}`}
        onClick={() => {
          swiperEl.current.swiper.slideNext();
        }}
      />
    </div>
  );
};
